<template>
  <div class="qiangzhipaicha">
    <el-alert
      title="未来强制执行地：当取得商事仲裁裁决书后，需要去哪个地方的中级人民法院申请强制执行，一般为败诉方的户籍所在地、常居地或财产所在地。"
      type="info"
      show-icon
    >
    </el-alert>
    <el-form
      :model="form"
      ref="form"
      label-position="left"
      label-width="150px"
      label-suffix="："
      size="mini"
      style="margin-top: 20px"
      @submit.native.prevent
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="name" label="审理机关">
            <el-select
              v-model="type"
              style="width: 258px"
              size="mini"
              placeholder="请选择合审理机关"
            >
              <el-option
                v-for="item in enforceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="form.type === 2">
          <el-form-item prop="name" label="未来强制执行地">
            <city v-model="cityId" style="width: 258px" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button
              class="btn"
              type="primary"
              @click="getEnforceAdviceList"
              :disabled="disabled"
              >提交</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import city from "@/components/form/city";
import selectData from "@/mixins/selectData.js";
import { mapState, mapActions } from "vuex";
export default {
  mixins: [selectData],
  components: {
    city,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("hetongqianshu", ["step"]),
    type: {
      get() {
        return this.$store.state.qiangzhi.type;
      },
      set(val) {
        this.setType(val);
      },
    },
    cityId: {
      get() {
        return this.$store.state.qiangzhi.cityId;
      },
      set(val) {
        this.setCityId(val);
      },
    },
    form() {
      return {
        type: this.type,
        cityId: this.cityId,
      };
    },
    disabled() {
      //  如果没有选择机关   不可提交
      if (!this.form.type) {
        return true;
      }
      //  如果选择2  却没有选择城市  不可提交
      if (this.form.type == 2 && !this.form.cityId) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    // console.log(this.$store.state.electronic.qiangzhipaichaData)
    // this.form = { ...this.$store.state.electronic.qiangzhipaichaData };
  },
  methods: {
    ...mapActions("qiangzhi", ["setType", "setCityId", "setjieguo","setQiangzhijieguoVisible"]),
    ...mapActions("hetongqianshu", ["setStep"]),
    async getEnforceAdviceList() {
      const { status, info, data } = await this.$api.getEnforceAdviceList(this.form);
      if (status === 200) {
        this.$message({
          type: "success",
          message: info,
        });
        this.setjieguo(data);
        this.setStep(this.step + 1);
        this.$emit("success")
        this.setQiangzhijieguoVisible(true)
      } else {
        this.$message({
          type: "error",
          message: info,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.qiangzhipaicha {
  padding: 0 16px;

  ::v-deep .el-form-item__label {
    text-align: end;
  }
  ::v-deep .el-alert--info{
    background-color: #F3F6F8;
    color: #262626;
    font-size: 14px;
    i{
      color: #0062FF;
    }
  }
  .btn {
    @include buttonStyle2;
  }
}
</style>
